import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  ItemsSelected: [],
  ItemID: "",
  ToggleStatus: "General",
  ItemDetails: {},
  ItemsSuppliers: [],
  ItemsTransactions: [],
  ProductBOM: [],
  CurrentID: null,
};
const itemSlice = createSlice({
  name: "item",
  initialState,
  reducers: {
    setProductBOM(state, action) {
      state.ProductBOM = action.payload;
    },
    setItemsTransactions(state, action) {
      state.ItemsTransactions = action.payload;
    },
    setItemsSuppliers(state, action) {
      state.ItemsSuppliers = action.payload;
    },
    setItemDetails(state, action) {
      state.ItemDetails = action.payload;
    },
    setStatus(state, action) {
      state.ToggleStatus = action.payload;
    },
    addItemID(state, action) {
      state.ItemID = action.payload;
    },
    SetCurrentID(state, action) {
      state.CurrentID = action.payload;
    },
    addItem(state, action) {
      const allItems = action.payload;
      return { ...state, ...allItems };
    },
    editItem(state: any, action) {
      return {
        ...state,
        data: state.data.map((item) =>
          item.slug === action.payload.slug
            ? { ...item, ...action.payload }
            : item
        ),
      };
    },
    deleteItem(state, action) {},
    getAllItems() {},
    setItems(state, action) {
      const allItems = action.payload;
      return { ...state, ...allItems };
    },
    setItemsSelected(state, action) {
      state.ItemsSelected = action.payload;
    },
  },
});

export const {
  addItem,
  getAllItems,
  editItem,
  setItems,
  deleteItem,
  setItemsSelected,
  addItemID,
  setStatus,
  setItemDetails,
  setItemsSuppliers,
  setItemsTransactions,
  setProductBOM,
  SetCurrentID,
} = itemSlice.actions;

export default itemSlice.reducer;
